<template>
  <div class="-row">
    <div class="tile -tile">
      <div>
        <h1>
          <mad-icon color="#704730" mdi="coffee" />&nbsp;

          Total vouchers
        </h1>

        <hr>

        <p>{{ form.amount_of_vouchers }}</p>
      </div>
    </div>
    <div class="tile -tile">
      <div>
        <h1>
          <mad-icon color="#704730" mdi="coffee-outline" />&nbsp;

          Used vouchers
        </h1>

        <hr>

        <p>{{ form.amount_of_used_vouchers }}</p>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  props: {
    form: { type: Object, default: null },
  },
}
</script>

<style scoped lang="scss">
h1 {
  text-align: center;
  padding-top: 10px;
  color: #666666;
}

p {
  text-align: center;
  margin-top: 22px;
  font-size: 60px;
  color: #666666;
}

.-tile {
  width: 325px;
  height: 250px;
}

.-row {
  margin-top: 20px;
  display: flex;
  justify-content: space-between;
}
</style>
